"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.friendlyDate = void 0;
function friendlyDate(date) {
    const localeDate = new Date(date).toLocaleString();
    const localeDateWithoutSeconds = localeDate.replace(/:\d\d\s/, ' ');
    return localeDateWithoutSeconds;
}
exports.friendlyDate = friendlyDate;
